/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');

var UIUtil = require('psa-core/util/ui');
var parsleyUtil = require('common/util/parsleyUtil');
var Constants = require('../../common/util/constants');

var COCCreateNewEntityModalView = require('./COCCreateNewEntityModalView');
var COCSearchForEntityModalView = require('./COCSearchForEntityModalView');
var COCCreateNewContactModalView = require('./COCCreateNewContactModalView');
var COCSearchForContactModalView = require('./COCSearchForContactModalView');
var Syphon = require('backbone.syphon');

var tmplCOCEventVenueDetailsView = require('../templates/COCEventVenueDetailsView.hbs');
require('../styles/COCEventVenueDetailsView.css');

module.exports = Marionette.LayoutView.extend({
  template: tmplCOCEventVenueDetailsView,

  className: 'coc-event-venue-details-view',

  ui: {
    venueDetailsForm: '.venue-details-form',
    venueName: '.venue-name-input',
    venueAddress: '.venue-address-input',
    contactName: '.contact-name-input',
    contactPhone: '.contact-phone-input',
    contactEmail: '.contact-email-input',
    selectVenueFormGroup: '.select-venue-form-group',
    selectVenueContactFormGroup: '.select-venue-contact-form-group',
    venueNameErrorsContainer: '#venueNameErrorsContainer',
    venueAddressErrorsContainer: '#venueAddressErrorsContainer',
    venueContactNameErrorsContainer: '#venueContactNameErrorsContainer',
    createEntity: '.btn-create-entity',
    searchEntity: '.btn-search-entity',
    createContact: '.btn-create-contact',
    searchContact: '.btn-search-contact'
  },

  events: {
    'click @ui.createEntity': 'onClickCreateEntity',
    'click @ui.searchEntity': 'onClickSearchEntity',
    'click @ui.createContact': 'onClickCreateContact',
    'click @ui.searchContact': 'onClickSearchContact'
  },

  behaviors: {
    ReadOnlyFormBehavior: {}
  },

  onBeforeShow: function() {
    if (this.options.isReadOnly) {
      var event = this.model.get('event') || {};
      event.venueName = event.venue.name;
      event.venueAddress = event.venue.fullAddress;
      event.venueContactName = event.venue.venueContactName;
      event.venuePhone = event.venue.contactPhone;
      event.venueEmail = event.venue.contactEmail;

      Syphon.deserialize(this, event);
    }
  },

  onClickCreateEntity: function(e) {
    e.preventDefault();
    var self = this;

    UIUtil.showModal({
      title: 'Create New Entity',
      dialogClasses: 'create-new-entity-modal-dialog',
      view: new COCCreateNewEntityModalView({
        model: new Backbone.Model({
          createEntityType: Constants.VENUE,
          entityTypes: self.model.get('entityTypes'),
          organizationTypes: self.model.get('organizationTypes')
        })
      })
    }).done(function(newEntity) {
      self.model.set('venueId', newEntity.newEntityId);
      self.ui.venueName.val(newEntity.name);
      self.ui.venueAddress.val(newEntity.fullAddress);
      self.model.set('venueAddress', {
        streetAddress: newEntity.addressLine1 + (newEntity.addressLine2 ? ' ' + newEntity.addressLine2 : ''),
        city: newEntity.city,
        postalCode: newEntity.postalCode,
        state: newEntity.state
      });

      if (self.ui.selectVenueFormGroup.hasClass('has-error')) {
        self.ui.selectVenueFormGroup.removeClass('has-error');
        self.ui.venueNameErrorsContainer.addClass('collapse');
        self.ui.venueAddressErrorsContainer.addClass('collapse');
      }
    });
  },

  onClickSearchEntity: function(e) {
    e.preventDefault();
    var self = this;

    UIUtil.showModal({
      title: 'Search for Entity',
      dialogClasses: 'search-for-entity-modal-dialog',
      view: new COCSearchForEntityModalView({
        model: new Backbone.Model({
          searchEntityType: Constants.VENUE,
          entityTypes: self.model.get('entityTypes'),
          organizationTypes: self.model.get('organizationTypes')
        })
      })
    }).done(function(selectedEntity) {
      self.model.set('venueId', selectedEntity.get('entityId'));
      self.ui.venueName.val(selectedEntity.get('entityName'));
      self.ui.venueAddress.val(selectedEntity.get('fullAddress'));
      self.model.set('venueAddress', {
        streetAddress: selectedEntity.get('streetAddress'),
        city: selectedEntity.get('city'),
        postalCode: selectedEntity.get('postalCode'),
        state: selectedEntity.get('state')
      });

      if (self.ui.selectVenueFormGroup.hasClass('has-error')) {
        self.ui.selectVenueFormGroup.removeClass('has-error');
        self.ui.venueNameErrorsContainer.addClass('collapse');
        self.ui.venueAddressErrorsContainer.addClass('collapse');
      }
    });
  },

  onClickCreateContact: function(e) {
    e.preventDefault();
    var self = this;

    UIUtil.showModal({
      title: 'Create New Contact',
      dialogClasses: 'create-new-contact-modal-dialog',
      view: new COCCreateNewContactModalView({
        model: new Backbone.Model()
      })
    }).done(function(newContact) {
      self.model.set('venueContactId', newContact.contactId);
      self.ui.contactName.val(newContact.name);
      self.ui.contactPhone.val(newContact.phone);
      self.ui.contactEmail.val(newContact.email);

      if (self.ui.selectVenueContactFormGroup.hasClass('has-error')) {
        self.ui.selectVenueContactFormGroup.removeClass('has-error');
        self.ui.venueContactNameErrorsContainer.addClass('collapse');
      }
    });
  },

  onClickSearchContact: function(e) {
    e.preventDefault();
    var self = this;

    UIUtil.showModal({
      title: 'Search For Contact',
      dialogClasses: 'search-for-contact-modal-dialog',
      view: new COCSearchForContactModalView({
        model: new Backbone.Model()
      })
    }).done(function(selectedContact) {
      console.log(selectedContact);
      selectedContact = selectedContact ? selectedContact : new Backbone.Model();
      self.model.set('venueContactId', selectedContact.get('contactId'));
      self.ui.contactName.val(selectedContact.get('contactName'));
      self.ui.contactPhone.val(selectedContact.get('contactPhone'));
      self.ui.contactEmail.val(selectedContact.get('contactEmail'));

      if (self.ui.selectVenueContactFormGroup.hasClass('has-error')) {
        self.ui.selectVenueContactFormGroup.removeClass('has-error');
        self.ui.venueContactNameErrorsContainer.addClass('collapse');
      }
    });
  },

  validate: function(config) {
    this.ui.venueDetailsForm.parsley().reset();
    if (config.type === 'save') {
      // Turn off required field validation for this form
      parsleyUtil.disableRequiredValidation(this.ui.venueDetailsForm);
    } else {
      // Turn on required field validation for this form
      parsleyUtil.enableRequiredValidation(this.ui.venueDetailsForm);
    }
    return this.ui.venueDetailsForm.parsley().whenValidate();
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);
    formData.venueId = this.model.get('venueId');
    formData.contactId = this.model.get('venueContactId');
    formData.venueAddress = this.model.get('venueAddress');
    return formData;
  }
});
